import { LatLng, Layer } from 'leaflet';
import { DrawPolyLine } from '../components/DrawControl.models/Draw.polyline';
import { AddVerticesCommandBase } from './addVerticesCommandBase';

export class AddPolylineVerticesCommand extends AddVerticesCommandBase {
  public polyline: DrawPolyLine;

  constructor(polyline: DrawPolyLine, latlng: LatLng) {
    super(latlng);
    this.polyline = polyline;
  }

  executeUndo(): void {
    if (this.polyline._markers.length === this.latlng.length) {
      this.polyline.disable();
      this.polyline.enable();
      return;
    }

    const oldLast = this.polyline._markers.at(-1);
    if (oldLast) {
      this.polyline._markerGroup.removeLayer(oldLast);
    }

    this.polyline._markers = this.polyline._markers.slice(0, this.polyline._poly._latlngs.length - this.latlng.length);
    this.polyline._poly.setLatLngs(this.polyline._poly._latlngs.slice(0, this.polyline._poly._latlngs.length - this.latlng.length));

    if (this.polyline._poly.getLatLngs().length < 2) {
      this.polyline._map.removeLayer(this.polyline._poly as unknown as Layer);
    }

    const newLast = this.polyline._markers.at(-1);
    if (newLast) {
      this.polyline._markerGroup.addLayer(newLast);
      this.polyline._vertexChanged(newLast.getLatLng(), false);
    }

    this.polyline._updateGuide();
  }

  executeRedo(): void {
    this.polyline._markers.push(this.polyline._createMarker(this.latlng.at(-1) as LatLng));
    this.polyline._poly.setLatLngs([...this.polyline._poly._latlngs, ...this.latlng]);

    const polyLayer = this.polyline._poly as unknown as Layer;

    if (!this.polyline._map.hasLayer(polyLayer)) {
      this.polyline._map.addLayer(polyLayer);
    }

    this.polyline._vertexChanged(this.latlng.at(-1) as LatLng, true);

    this.polyline._updateGuide();
  }
}
